
define(
	'MHI.MinimumOrder.Main'
,   [
		'PDP.Quantity.View',
		'Cart.Item.Summary.View.Ext',
		'QuickAdd.View.Ext'
	]
,   function (
		PDPQuantityView,
		CartItemSummaryViewExt,
		QuickAddViewExt
	)
{
	'use strict';

	return  {
		mountToApp: function mountToApp (container) {
			PDPQuantityView.loadModule( container );
		}
	};
});
